import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../css/common.css';
import '../css/hover.css';
import LoadingScreen from '../skeletons/loadingSkeleton.jsx';
import Header from './navbar';
import { getForm } from '../store/Slices/formSlice';
import Select from 'react-select';
 
import French from './france/french';
import English from './france/english';
import Internalenglish from './franceInternal/internalEnglish.js';
import Internalfrench from './franceInternal/internalFrench.js';
import ItalyEnglish from './italy/english';
import Italian from './italy/italian';
import Usa from './usa';
import Germany from './germany';
import Canada from './canada';
import UkIreland from './ukireland.js';
import Ireland from './ireland';
import PortugueseEnglish from './portugal/english.js';
import Portuguese from './portugal/portuguese.js';
import Belgium from './belgium.js';
import Switzerland from './switzerland.js';
import Spain from './spain.js';
import Netherlands from './netherlands.js';
import Hongkong from './hongkong.js';
import Sweden from './sweden.js';
import Norway from './norway.js';
import Luxembourg from './luxembourg.js';
import Austria from './austria.js';
import Denmark from './denmark.js';
import Australia from './australia.js';
import Newzealand from './newzealand.js';
import Greece from './greece.js';
import Romania from './romania.js';
import Hungary from './hungary.js';
import Singapore from './singapore.js';
import Finland from './finland.js';
import Slovenia from './slovenia.js';
import Slovakia from './slovakia.js';
import Croatian from './croatia/croatian.js';
import CroatiaEnglish from './croatia/english.js';
import TollfreeEnglish from './francetollfree/tollfreeEnglish.js';
import TollfreeFrench from './francetollfree/tollfreeFrench.js';
import UsaTollFree from './UsaTollFree.js';
import UsaPstn from './usaPstn.js';
 
function Home() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const email = sessionStorage.getItem('email');
 
    // FORM TYPE
    const [selectedType, setSelectedType] = useState('Local Voice Service');
 
    // State for selected country, default is 'France'
    const [selectedCountry, setSelectedCountry] = useState('France');
 
    // State for selected language, default is 'English'
    const [selectedLanguage, setSelectedLanguage] = useState('english');
 
    const loading = useSelector((state) => state.form.loading);
 
    const [isFocused, setIsFocused] = useState(false);
    const selectRef = useRef(null);
 
    // FETCH EXISTING FORM DATA
    useEffect(() => {
        const fetchData = async () => {
            if (!email) {
                navigate('/');
                return;
            }
 
            const data = { "email": email };
 
            dispatch(getForm(data)).then((response) => {
                const form = response?.payload?.form;
 
                if (form) {
                    setSelectedCountry(form?.country?.country);
                    localStorage.setItem('form', JSON.stringify(form));
                   
                }
            });
        };
 
        fetchData();
    }, [email, navigate, dispatch]);
 
    // FORM TYPE OPTIONS
    const typeOptions = [
        { value: 'Local Voice Service', label: 'Local Voice Service' },
        { value: 'Contact Center Access', label: 'Contact Center Access' }
    ];
 
    // LVS COUNTRY OPTIONS
    const lvsCountryOptions = [
        { value: "France", label: "France_DROM_COM" },
        { value: "France Internal", label: "France_DROM_COM (Internal)" },
        { value: "Germany", label: "Germany" },
        { value: "Usa", label: "USA" },
        { value: "Canada", label: "Canada" },
        { value: "United Kingdom & Ireland", label: "UK" },
        { value: "Ireland", label: "Ireland" },
        { value: "Italy", label: "Italy" },
        { value: "Portugal", label: "Portugal" },
        { value: "Belgium", label: "Belgium" },
        { value: "Switzerland", label: "Switzerland" },
        { value: "Spain", label: "Spain" },
        { value: "Netherlands", label: "Netherlands" },
        { value: "Hongkong", label: "Hong Kong (SAR)" },
        { value: "Sweden", label: "Sweden" },
        { value: "Norway", label: "Norway" },
        { value: "Luxembourg", label: "Luxembourg" },
        { value: "Denmark", label: "Denmark" },
        { value: "Austria", label: "Austria" },
        { value: "Australia", label: "Australia" },
        { value: "Newzealand", label: "New Zealand" },
        { value: "Greece", label: "Greece" },
        { value: "Romania", label: "Romania" },
        { value: "Hungary", label: "Hungary" },
        { value: "Singapore", label: "Singapore" },
        { value: "Finland", label: "Finland" },
        { value: "Slovenia", label: "Slovenia" },
        { value: "Slovakia", label: "Slovakia" },
        { value: "Croatia", label: "Croatia" },
 
    ];
 
    // CCA COUNTRY OPTIONS
    const ccaCountryOptions = [
        { value: "Francetollfree", label: "France_Toll free" },
        { value: "France", label: "France_DROM_COM" },
        { value: "France Internal", label: "France_DROM_COM (Internal)" },
        { value: "UsaTollFree", label: "USA_Toll Free" },
        { value: "UsaPstn", label: "USA_PSTN" }
    ];
 
    // HANDLE FORM TYPE CHANGE
    const handleTypeChange = (selectedOption) => {
        const type = selectedOption.value;
 
        setSelectedType(type);
 
        if (type === 'Local Voice Service') {
            setSelectedCountry('France');
            setSelectedLanguage('english');
        } else if (type === 'Contact Center Access') {
            setSelectedCountry('Francetollfree');
            setSelectedLanguage('english');
        }
 
        selectRef.current?.blur();
    };
 
    // HANDLE COUNTRY CHANGE
    const handleDropdownChange = (selectedOption) => {
        setSelectedCountry(selectedOption.value);
    };
 
    // HANDLE LANGUAGE CHANGE
    const handleLanguageChange = (selectedOption) => {
        if (selectedOption) {
            setSelectedLanguage(selectedOption.value);
        }
    };
 
    // RENDER FRANCE FORM (shared by LVS and CCA)
    const renderFranceForm = (country, language) => {
        if (country === 'France') {
            return language === 'english' ? <English /> : <French />;
        }
        if (country === 'France Internal') {
            return language === 'english' ? <Internalenglish /> : <Internalfrench />;
        }
        return null;
    };
 
    // RENDER FORM CONTENT
    const renderContent = () => {
 
        // CCA FORMS
        if (selectedType === 'Contact Center Access') {
 
            switch (selectedCountry) {
 
                case 'Francetollfree':
                    return selectedLanguage === 'english'
                        ? <TollfreeEnglish />
                        : <TollfreeFrench />;
 
                case 'France':
                    return selectedLanguage === 'english'
                        ? <English />
                        : <French />;
 
                case 'France Internal':
                    return selectedLanguage === 'english'
                        ? <Internalenglish />
                        : <Internalfrench />;
 
                case 'UsaTollFree':
                    return <UsaTollFree />;
                   
                case 'UsaPstn':
                    return <UsaPstn />;
 
                default:
                    return null;
            }
        }
 
        // LVS FORMS
        if (selectedType === 'Local Voice Service') {
 
            switch (selectedCountry) {
 
                case 'France':
                case 'France Internal':
                    return renderFranceForm(selectedCountry, selectedLanguage);
 
                case 'Italy':
                    return selectedLanguage === 'english'
                        ? <ItalyEnglish />
                        : <Italian />;
 
                case 'Germany':
                    return <Germany />;
 
                case 'United Kingdom & Ireland':
                    return <UkIreland />;
 
                case 'Usa':
                    return <Usa />;
 
                case 'Canada':
                    return <Canada />;
 
                case 'Ireland':
                    return <Ireland />;
 
                case 'Belgium':
                    return <Belgium />;
 
                case 'Portugal':
                    return selectedLanguage === 'english'
                        ? <PortugueseEnglish />
                        : <Portuguese />;
 
                case 'Switzerland':
                    return <Switzerland />;
 
                case 'Spain':
                    return <Spain />;
 
                case 'Netherlands':
                    return <Netherlands />;
 
                case 'Hongkong':
                    return <Hongkong />;
 
                case 'Sweden':
                    return <Sweden />;
 
                case 'Norway':
                    return <Norway />;
 
                case 'Luxembourg':
                    return <Luxembourg />;
 
                case 'Austria':
                    return <Austria />;
 
                case 'Denmark':
                    return <Denmark />;
 
                case 'Australia':
                    return <Australia />;
 
                case 'Newzealand':
                    return <Newzealand />;
 
                case 'Greece':
                    return <Greece />;
 
                case 'Romania':
                    return <Romania />;
 
                case 'Hungary':
                    return <Hungary />;
 
                case 'Singapore':
                    return <Singapore />;
 
                case 'Finland':
                    return <Finland />;
 
                case 'Slovenia':
                    return <Slovenia />;
 
                case 'Slovakia':
                    return <Slovakia />;
 
                case 'Croatia':
                    return selectedLanguage === 'english'
                        ? <CroatiaEnglish />
                        : <Croatian />;
 
                default:
                    return null;
            }
        }
 
        return null;
    };
 
    // MAIN JSX
    return (
        <div>
 
            <Header />
 
            {loading ? (
                <LoadingScreen />
            ) : (
 
                <div className='french'>
 
                    <Container>
 
                        {/* DROPDOWNS */}
 
                        <Row>
 
                            <Col></Col>
 
                            <Col xs={5}>
 
                                <label>Select Type</label> <br />
 
                                <Select
                                    options={typeOptions}
                                    value={typeOptions.find(
                                        option => option.value === selectedType
                                    )}
                                    onChange={handleTypeChange}
                                    className='inputbox'
                                    isSearchable={false}
                                    placeholder="Select Type"
                                />
 
                            </Col>
 
                            <Col xs={5}>
 
                                {selectedType === 'Local Voice Service' && (
                                    <div>
 
                                        <label>
                                            Select Countries or Territories
                                        </label> <br />
 
                                        <Select
                                            ref={selectRef}
                                            options={lvsCountryOptions}
                                            value={
                                                isFocused
                                                    ? null
                                                    : lvsCountryOptions.find(
                                                        option =>
                                                            option.value === selectedCountry
                                                    )
                                            }
                                            onChange={(selectedOption) => {
                                                if (selectedOption) {
                                                    handleDropdownChange(selectedOption);
                                                }
                                                selectRef.current?.blur();
                                            }}
                                            className='inputbox'
                                            isSearchable
                                            placeholder=""
                                            onFocus={() => setIsFocused(true)}
                                            onBlur={() => setIsFocused(false)}
                                        />
 
                                    </div>
                                )}
 
                                {selectedType === 'Contact Center Access' && (
                                    <div>
 
                                        <label>
                                            Select CCA Country
                                        </label> <br />
 
                                        <Select
                                            options={ccaCountryOptions}
                                            value={
                                                ccaCountryOptions.find(
                                                    option =>
                                                        option.value === selectedCountry
                                                ) || null
                                            }
                                            onChange={(selectedOption) => {
                                                if (selectedOption) {
                                                    setSelectedCountry(
                                                        selectedOption.value
                                                    );
                                                }
                                            }}
                                            className='inputbox'
                                            isSearchable
                                            placeholder="Select CCA Country"
                                        />
 
                                    </div>
                                )}
 
                            </Col>
 
                            <Col></Col>
 
                        </Row>
 
                        <br />
 
                        <Row>
 
                            <Col></Col>
 
                            <Col xs={5}>
 
                                {selectedType === 'Local Voice Service' &&
                                    selectedCountry === 'France' && (
 
                                        <div>
 
                                            <label>Select Language</label> <br />
 
                                            <Select
                                                id="language"
                                                options={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'french', label: 'French' }
                                                ]}
                                                value={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'french', label: 'French' }
                                                ].find(
                                                    option =>
                                                        option.value === selectedLanguage
                                                )}
                                                onChange={handleLanguageChange}
                                                className='inputbox'
                                                isSearchable={false}
                                                placeholder="Select Language"
                                            />
 
                                        </div>
                                    )
                                }
 
 
                                {selectedType === 'Local Voice Service' &&
                                    selectedCountry === 'France Internal' && (
 
                                        <div>
 
                                            <label>Select Language</label> <br />
 
                                            <Select
                                                id="language"
                                                options={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'french', label: 'French' }
                                                ]}
                                                value={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'french', label: 'French' }
                                                ].find(
                                                    option =>
                                                        option.value === selectedLanguage
                                                )}
                                                onChange={handleLanguageChange}
                                                className='inputbox'
                                                isSearchable={false}
                                                placeholder="Select Language"
                                            />
 
                                        </div>
                                    )
                                }
 
 
                                {selectedType === 'Local Voice Service' &&
                                    selectedCountry === 'Italy' && (
 
                                        <div>
 
                                            <label>Select Language</label> <br />
 
                                            <Select
                                                id="language"
                                                options={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'italian', label: 'Italian' }
                                                ]}
                                                value={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'italian', label: 'Italian' }
                                                ].find(
                                                    option =>
                                                        option.value === selectedLanguage
                                                )}
                                                onChange={handleLanguageChange}
                                                className='inputbox'
                                                isSearchable={false}
                                                placeholder="Select Language"
                                            />
 
                                        </div>
                                    )
                                }
 
 
                                {selectedType === 'Local Voice Service' &&
                                    selectedCountry === 'Portugal' && (
 
                                        <div>
 
                                            <label>Select Language</label> <br />
 
                                            <Select
                                                id="language"
                                                options={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'portuguese', label: 'Portuguese' }
                                                ]}
                                                value={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'portuguese', label: 'Portuguese' }
                                                ].find(
                                                    option =>
                                                        option.value === selectedLanguage
                                                )}
                                                onChange={handleLanguageChange}
                                                className='inputbox'
                                                isSearchable={false}
                                                placeholder="Select Language"
                                            />
 
                                        </div>
                                    )
                                }
 
 
                                {selectedType === 'Local Voice Service' &&
                                    selectedCountry === 'Croatia' && (
 
                                        <div>
 
                                            <label>Select Language</label> <br />
 
                                            <Select
                                                id="language"
                                                options={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'croatian', label: 'Croatian' }
                                                ]}
                                                value={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'croatian', label: 'Croatian' }
                                                ].find(
                                                    option =>
                                                        option.value === selectedLanguage
                                                )}
                                                onChange={handleLanguageChange}
                                                className='inputbox'
                                                isSearchable={false}
                                                placeholder="Select Language"
                                            />
 
                                        </div>
                                    )
                                }
 
                                {selectedType === 'Contact Center Access' &&
                                    (selectedCountry === 'Francetollfree' ||
                                        selectedCountry === 'France' ||
                                        selectedCountry === 'France Internal') && (
 
                                        <div>
 
                                            <label>Select Language</label> <br />
 
                                            <Select
                                                id="language"
                                                options={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'french', label: 'French' }
                                                ]}
                                                value={[
                                                    { value: 'english', label: 'English' },
                                                    { value: 'french', label: 'French' }
                                                ].find(
                                                    option =>
                                                        option.value === selectedLanguage
                                                )}
                                                onChange={handleLanguageChange}
                                                className='inputbox'
                                                isSearchable={false}
                                                placeholder="Select Language"
                                            />
 
                                        </div>
                                    )
                                }
 
                            </Col>
 
                            <Col></Col>
 
                        </Row>
 
                        {/* FORM CONTENT */}
 
                        <Row>
 
                            <Col>
                                {renderContent()}
                            </Col>
 
                        </Row>
 
                    </Container>
 
                    <br /><br />
 
                </div>
            )}
 
        </div>
    );
}
 
export default Home;
 